export default {"src":"/_next/static/media/ship.da0afd2d.svg","height":63,"width":96};